<template>
  <div
    v-if="user.data.email === author || pollKey == null"
    class="add-poll bg-gray-100 h-screen md:h-extend"
  >
    <v-dialog />
    <PageTitle title="Create your poll" />
    <div class="container mx-auto">
      <div class="md:flex flex-grow mt-2 mb-2">
        <!-- Forms and Accordion -->
        <div class="w-full h-screen md:w-1/2 p-2">
          <form>
            <ul class="mt-4">
              <li v-for="(option, index) in options" v-bind:key="index">
                <a
                  class="p-4 bg-push-black cursor-pointer hover:bg-push-gray text-white w-full block border border-b-1 "
                  v-if="accr == index"
                  @click="accr = null"
                  >{{ option.title
                  }}<i
                    v-if="accr == index"
                    @click="accr = null"
                    class="fas float-right mt-1 fa-minus-circle"
                  ></i
                ></a>
                <a
                  v-if="accr != index"
                  class="p-4 bg-push-black cursor-pointer hover:bg-push-gray text-white w-full block border border-b-1 "
                  @click="accr = index"
                  >{{ option.title }}
                  <i class="fas float-right mt-1 fa-plus-circle"></i
                ></a>
                <div
                  v-if="accr == index"
                  class="animate__animated animate__fadeIn pt-4 pb-4"
                >
                  <!-- Form -->
                  <span v-if="option.htmlContent == 'q-a-form'">
                    <div v-if="pollKey" class="mt-2">
                      <label><b>Poll link</b></label>
                      <div class="bg-white p-2 border">
                        {{ base + pollKey }}
                      </div>
                    </div>
                    <div class="mt-2">
                      <label><b>Question</b></label>
                      <div class="relative">
                        <textarea
                          required
                          v-model="question"
                          style="min-height:100px"
                          class="border w-full mt-2 mt-2 py-2 px-4"
                        ></textarea>
                        <span
                          class="absolute right-0 bottom-0 m-2 text-push-gray"
                          v-if="!isOverQuestion()"
                          >{{ charactersRemainingQuestion }}</span
                        >
                        <span v-else class="over"
                          >- {{ charactersOverQuestion }}</span
                        >
                      </div>
                    </div>
                    <!-- Answers Yes_no -->
                    <div v-if="type == 'yes_no'" class="mt-4">
                      <label><b>Answer 1</b></label>
                      <input
                        class="block border w-full py-2 px-4"
                        type="text"
                        placeholder="Yes"
                        disabled
                      />
                    </div>
                    <div v-if="type == 'yes_no'" class="mt-4">
                      <label><b>Answer 2</b></label>
                      <input
                        class="block border w-full py-2 px-4"
                        type="text"
                        placeholder="No"
                        disabled
                      />
                    </div>
                    <!-- Answers Multiple -->
                    <div class="block w-full" v-if="type == 'multiple'">
                      <div
                        v-for="(answer, index) in answers"
                        v-bind:key="index"
                        class="mt-4 relative"
                      >
                        <label
                          ><b>Answer {{ index + 1 }}</b></label
                        >
                        <input
                          class="block border w-full py-2 px-4 pr-10"
                          type="text"
                          v-model="answer.label"
                          required
                          :placeholder="answer.placeholder"
                        />
                        <a
                          class="remove absolute right-0 text-xl text-push-orange bottom-0 mb-1 mr-3"
                          v-if="index > 1"
                          @click="removeInput(index)"
                          ><i class="fas fa-minus-circle"></i
                        ></a>
                      </div>
                      <a
                        class="mt-2 block cursor-pointer w-full text-right text-2xl text-push-blue"
                        v-if="type == 'multiple'"
                        @click="addInput"
                        ><i class="fas fa-plus-circle"></i
                      ></a>
                    </div>
                  </span>

                  <!-- Custom Answer -->
                  <span v-if="option.htmlContent == 'custom-answer'">
                    <div class="mt-2">
                      <label><b>Customise Answer</b></label>
                      <p class="text-xs text-gray-800">
                        This message will appear to the repsondant after they
                        have answered the poll
                      </p>
                      <div class="relative">
                        <textarea
                          required
                          v-model="custom_answer"
                          style="min-height:100px"
                          class="border w-full mt-2 mt-2 py-2 px-4"
                        ></textarea>
                        <span
                          class="absolute right-0 bottom-0 m-2 text-push-gray"
                          v-if="!isOverAnswer()"
                          >{{ charactersRemainingAnswer }}</span
                        >
                        <span v-else class="over"
                          >- {{ charactersOverAnswer }}</span
                        >
                      </div>
                    </div>
                  </span>

                  <!-- Dates -->
                  <span v-if="option.htmlContent == 'time-date'">
                    <div class="flex flex-auto">
                      <div class="w-1/4">
                        <label class="p-2 pl-0 mb-2"><b>Starts</b></label>
                        <input
                          class="p-2 border block w-full"
                          required
                          type="text"
                          id="start_date"
                          name="start_date"
                          v-model="range.start"
                        />
                      </div>
                      <vue-timepicker
                        class="block mt-6 w-1/4"
                        required
                        id="start_time"
                        v-model="timeValueStart"
                        name="start_time"
                        :minute-interval="30"
                      ></vue-timepicker>
                      <div class="w-1/4">
                        <label class="p-2 mb-2"><b>Ends</b></label>
                        <input
                          class="p-2 border block w-full"
                          required
                          type="text"
                          id="end_date"
                          name="end_date"
                          v-model="range.end"
                        />
                      </div>
                      <vue-timepicker
                        class="block mt-6 w-1/4"
                        required
                        id="end_time"
                        name="end_time"
                        v-model="timeValueEnd"
                        :minute-interval="30"
                      ></vue-timepicker>
                    </div>
                    <br />
                    <v-range-selector
                      :start-date.sync="range.start"
                      :end-date.sync="range.end"
                    />
                  </span>
                  <!-- Customisations -->
                  <span v-if="option.htmlContent == 'customise'">
                    <div class="my-2">
                      <label class="block mb-2">
                        <b>Upload a custom logo</b>
                      </label>

                      <vue-dropzone
                        ref="dropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        @vdropzone-complete="afterComplete"
                      ></vue-dropzone>
                    </div>

                    <div class="flex flex-wrap">
                      <div class="w-1/2 mb-2">
                        <label class="float-left mb-2"
                          ><b>Odd Background</b></label
                        >
                        <verte
                          picker="square"
                          model="hex"
                          v-model="custom.obgcolor"
                        ></verte>
                        <input
                          type="text"
                          class="p-2 border"
                          v-model="custom.obgcolor"
                        />
                      </div>
                      <div class="w-1/2 mb-2">
                        <label class="float-left mb-2"
                          ><b>Odd Text Colour</b></label
                        >
                        <verte
                          picker="square"
                          model="hex"
                          v-model="custom.otcolor"
                        ></verte>
                        <input
                          type="text"
                          class="p-2 border"
                          v-model="custom.otcolor"
                        />
                      </div>
                      <div class="w-1/2">
                        <label class="float-left mb-2"
                          ><b>Even Background</b></label
                        >
                        <verte
                          picker="square"
                          model="hex"
                          v-model="custom.ebgcolor"
                        ></verte>
                        <input
                          type="text"
                          class="p-2 border"
                          v-model="custom.ebgcolor"
                        />
                      </div>
                      <div class="w-1/2">
                        <label class="float-left mb-2"
                          ><b>Even Text Colour</b></label
                        >
                        <verte
                          picker="square"
                          model="hex"
                          v-model="custom.etcolor"
                        ></verte>
                        <input
                          type="text"
                          class="p-2 border"
                          v-model="custom.etcolor"
                        />
                      </div>
                    </div>
                  </span>
                </div>
              </li>
            </ul>
            <!-- Publishing Buttons-->
            <div class="flex mt-4 publish">
              <div class="w-2/3">
                <h5>Remember to check your Poll before publishing</h5>
                <p class="uk-text-small">
                  Don't worry if you, or someone better at spelling spots a
                  mistake, you can edit it at anytime in the
                  <a href="/dashboard">dashboard</a>
                </p>
              </div>
              <div class="w-1/3 ml-3">
                <button
                  id="publish"
                  @click="CreatePoll"
                  class="bg-push-orange text-white py-2 w-full border uppercase pl-4 pr-4 mr-2 inline-block"
                >
                  {{ update_type }}
                </button>
              </div>
            </div>
          </form>
        </div>

        <!-- Preview Half-->
        <div class="w-full md:w-1/2 p-2">
          <!-- Previewer -->
          <div class="p-2 h-full">
            <div class="mt-2 text-xl text-push-orange">
              <h3>Preview</h3>
              <div class="flex">
                <a
                  @click="previewToggle(preview.state)"
                  v-for="(preview, i) in previewselectoutput"
                  v-bind:key="i"
                >
                  <span>
                    <img v-bind:src="preview.img" />
                  </span>
                </a>
              </div>
            </div>
            <div id="Preview" class="preview h-full text-center">
              <div
                :style="{ height: previewheight + 'px' }"
                :class="[
                  width,
                  answersCount > 2
                    ? 'overflow-scroll relative'
                    : 'overflow-hidden'
                ]"
                class="mx-auto h-full bg-white"
              >
                <div class="text-center w-full py-6">
                  <div class="logo mx-auto table py-6">
                    <img
                      v-if="!logotemp"
                      v-bind:src="custom.logo"
                      v-bind:width="size"
                    />
                    <img
                      v-if="logotemp"
                      v-bind:src="logotemp"
                      v-bind:width="size"
                    />
                  </div>
                  <div class="question mt-4 mb-4">
                    <span v-if="!question">Nothing to see here</span>
                    <span v-else>{{ question }}</span>
                    <br />
                    <!--<a
                      v-if="answersCount > 2"
                      v-on:click="overlayOn = true"
                      class="border p-2 px-4 inline-block mt-4"
                      >All Answers</a
                    >-->
                  </div>
                </div>

                <div class="poll-bottom flex flex-wrap h-full">
                  <div
                    v-if="type == 'yes_no'"
                    class="h-full pt-12"
                    v-bind:class="[gridType]"
                    v-bind:style="{ background: custom.obgcolor }"
                  >
                    <span
                      class="circle-container block border-8 rounded-full border-white w-24 mx-auto h-24 relative"
                    >
                      <span
                        class="circle absolute left-0 w-full object-center -mt-1"
                        v-bind:style="{ 'border-color': custom.otcolor }"
                      >
                        <span
                          class="text-4xl font-playfair leading-none "
                          v-bind:style="{ color: custom.otcolor }"
                          >yes</span
                        >
                      </span>
                    </span>
                  </div>

                  <div
                    v-if="type == 'yes_no'"
                    class="h-full pt-12"
                    v-bind:class="[gridType]"
                    v-bind:style="{ background: custom.ebgcolor }"
                  >
                    <span
                      class="circle-container block border-8 rounded-full border-white w-24 mx-auto h-24 relative"
                    >
                      <span
                        class="circle absolute left-0 w-full object-center -mt-1"
                        v-bind:style="{ 'border-color': custom.etcolor }"
                      >
                        <span
                          class="text-4xl font-playfair leading-none "
                          v-bind:style="{ color: custom.etcolor }"
                          >no</span
                        >
                      </span>
                    </span>
                  </div>
                  <div
                    class="block flex flex-wrap w-full"
                    v-if="type == 'multiple'"
                  >
                    <div
                      v-for="(answer, index) in answers"
                      v-bind:key="index"
                      class="answer-block p-3"
                      v-bind:class="[gridType]"
                      v-bind:style="{ background: customStylesBg(index) }"
                    >
                      <span
                        v-bind:style="{ color: customStylesFg(index) }"
                        class="multiple-text mb-4 block"
                        >{{ answer.label }}</span
                      >

                      <span
                        class="circle-container block border-8 rounded-full border-white w-24 mx-auto h-24 relative"
                      >
                        <span
                          class="circle absolute left-0 w-full object-center -mt-1"
                          v-bind:style="{
                            'border-color': customStylesFg(index)
                          }"
                        >
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- Overlay -->
                <div
                  :style="{ height: previewheight + 'px' }"
                  v-if="answersCount > 2 && overlayOn"
                  class="absolute top-0 left-0 w-full"
                >
                  <a
                    v-on:click="overlayOn = 0"
                    class="absolute top-0 right-0 z-75 mt-2 mr-4 text-white"
                    ><i class="fas fa-times"></i
                  ></a>

                  <div class="block w-full" v-if="type == 'multiple'">
                    <div
                      v-for="(answer, index) in answers"
                      v-bind:key="index"
                      class="answer-block block flex"
                      :style="{
                        height: OverlayHeight + 'px',
                        background: customStylesBg(index)
                      }"
                    >
                      <span
                        class="circle-container block border-4 rounded-full border-white w-10 m-4 h-10 relative"
                      >
                        <span
                          :style="{ 'border-color': customStylesFg(index) }"
                          class="circle absolute left-0 w-full object-center -mt-1"
                        >
                        </span>
                      </span>
                      <span
                        :style="{ color: customStylesFg(index) }"
                        class="multiple-text mt-4"
                        >{{ answer.label }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import firebase, { functions } from "firebase";
import VRangeSelector from "vuelendar/components/vl-range-selector";
import VueTimepicker from "vue2-timepicker";
import moment from "moment";
import verte from "verte";
import vueDropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import "verte/dist/verte.css";
import PageTitle from "@/components/header/PageTitle.vue";
import vmodal from "vue-js-modal";

export default {
  components: {
    PageTitle,
    VRangeSelector,
    VueTimepicker,
    verte,
    vueDropzone
  },
  data() {
    return {
      accr: 0,
      toggled: false,
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        maxFilesize: 2, // MB
        maxFiles: 1,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true
      },
      logotemp: require("@/assets/img/LogoPPmedium.png"),
      custom: {
        name: "Default",
        logo: require("@/assets/img/LogoPPmedium.png"),
        obgcolor: "#0066ff",
        otcolor: "#ffffff",
        ebgcolor: "#3c3c3b",
        etcolor: "#ffffff"
      },
      selected_profile: "Default",
      customProfiles: [
        {
          name: "Default",
          logo: require("@/assets/img/LogoPPmedium.png"),
          obgcolor: "#0066ff",
          otcolor: "#ffffff",
          ebgcolor: "#3c3c3b",
          etcolor: "#ffffff"
        }
      ],
      savedName: null,
      addprofile: false,
      pollKey: null,
      update_type: "Publish poll",
      title: "Create your poll",
      size: "90px",
      alt: "Push Poll",
      range: {
        start: null,
        end: null
      },
      date: null,
      options: [
        {
          title: "Add questions and answer options",
          isActive: false,
          htmlContent: "q-a-form"
        },
        {
          title: "Customise your answer response",
          isActive: false,
          htmlContent: "custom-answer"
        },
        {
          title: "Schedule poll - start and end dates and times",
          isActive: false,
          htmlContent: "time-date"
        },
        {
          title: "Customise your poll",
          isActive: false,
          htmlContent: "customise"
        }
      ],
      type: "multiple",
      custom_answer: "",
      question: "",
      maxCharacters: 100,
      isOverMonitorQuestion: false,
      isOverMonitorAnswer: false,
      answers: [
        { label: "yes", placeholder: "", answer_count: 0 },
        { label: "no", placeholder: "", answer_count: 0 }
      ],
      answersCount: 0,
      selected: 0,
      width: "w-1/2",
      gridType: "w-1/2",
      overlayOn: false,
      previewselectoutput: [
        { img: require("@/assets/img/phone-on.png"), state: "phone" },
        { img: require("@/assets/img/desktop-off.png"), state: "desktop" }
      ],
      timeValueStart: {
        HH: null,
        mm: null
      },
      timeValueEnd: {
        HH: null,
        mm: null
      },
      userId: null,
      createArray: {},
      base: null,
      today: null,
      previewheight: 600,
      device: "phone",
      alertmessage: null,
      author: null
    };
  },
  created() {
    window.addEventListener("resize", this.WindowWidth);
    window.addEventListener("resize", this.answersHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.WindowWidth);
    window.addEventListener("resize", this.answersHeight);
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    // Clone Answers for multiple
    addInput() {
      this.answers.push({
        label: "",
        placeholder: "add your answer here",
        answer_count: 0
      });
      this.answersCount = this.answers.length;
      // Grid Type
      if (this.answersCount < 3) {
        this.gridType = "w-1/2" && this.device != "phone";
      }
      if (this.answersCount == 3 && this.device != "phone") {
        this.gridType = "w-1/3";
      }
      if (this.answersCount == 4 && this.device != "phone") {
        this.gridType = "w-1/4";
      }
      if (this.answersCount > 4 && this.device != "phone") {
        this.gridType = "w-1/5";
      }
    },
    previewToggle(state) {
      this.device = state;
      if (state == "phone") {
        this.width = "w-1/2";
        this.gridType = "w-1/2";
        this.previewselectoutput = [
          { img: require("@/assets/img/phone-on.png"), state: "phone" },
          { img: require("@/assets/img/desktop-off.png"), state: "desktop" }
        ];
      }
      if (state == "desktop") {
        this.width = "w-full";
        this.previewselectoutput = [
          { img: require("@/assets/img/phone-off.png"), state: "phone" },
          { img: require("@/assets/img/desktop-on.png"), state: "desktop" }
        ];
        if (this.answersCount < 3) {
          this.gridType = "w-1/2";
        }
        if (this.answersCount == 3) {
          this.gridType = "w-1/3";
        }
        if (this.answersCount == 4) {
          this.gridType = "w-1/4";
        }
        if (this.answersCount > 4) {
          this.gridType = "w-1/5";
        }
      }
    },
    loadUserProfile() {
      const uid = this.user.data.uid;

      if (uid) {
        var firestore = firebase.firestore();

        var docRefuser = firestore.doc("users/" + uid);
        //Update UserData
        docRefuser
          .get()
          .then(
            function(profile) {
              const profileData = profile.data();
              if (profileData.profiles) {
                this.custom = profileData.profiles;
                this.logotemp = profileData.profiles.logo;
              }

              this.toggled = true;
            }.bind(this)
          )
          .catch(function(error) {
            console.log("got and error", error);
          });
      }
    },

    getSelectedProfile() {
      var vm = this;
      var selected_profile = this.selected_profile;
      var customProfiles = this.customProfiles;
      customProfiles.forEach(profile => {
        if (selected_profile === profile.name) {
          //console.log(profile);
          this.custom = profile;
          // Logo Temp
          this.logotemp = profile.logo;
        }
      });
    },

    todayDate: function() {
      return (this.today = moment().format("YYYY-MM-DD"));
    },

    dateValidation() {
      var today = this.todayDate();
      var endDate = this.range.end;
      var startDate = this.range.start;

      if (today > endDate) {
        this.$modal.show("dialog", {
          title: "Hey!",
          text: "This poll has already ended.",
          buttons: [
            {
              title: "Okay",
              handler: () => {
                this.accr = 1;
                this.$modal.hide("dialog");
              }
            }
          ]
        });
      }

      if (startDate < today && today < endDate) {
        this.$modal.show("dialog", {
          title: "Hey!",
          text:
            "This poll has already started and is currently active. <em>Tip: check if there has been any data collected, if not, it's probably okay to make some changes</em>",
          buttons: [
            {
              title: "Okay",
              handler: () => {
                this.accr = 0;
                this.$modal.hide("dialog");
              }
            }
          ]
        });
      }

      if (startDate > today) {
        this.$modal.show("dialog", {
          title: "Hey!",
          text:
            "This poll is yet to begin. <em>Tip: It's probably okay to make some changes</em>",
          buttons: [
            {
              title: "Okay",
              handler: () => {
                this.accr = 0;
                this.$modal.hide("dialog");
              }
            }
          ]
        });
      }
    },

    getFBimage() {
      var filename = this.custom.logo;
      if (filename) {
        this.logotemp = filename;
      }
    },

    afterComplete(file) {
      var vm = this;
      console.log(file);
      //Set temp logo
      this.logotemp = file.dataURL;
      //Store in firebase

      var storageRef = firebase
        .storage()
        .ref("images/" + this.alphanumericUnique + file.name);
      var task = storageRef.put(file);
      task.on(
        "state_changed",

        function progress(snapshot) {
          console.log(snapshot);
        },
        function error(err) {
          console.log(err);
        },
        function complete() {
          storageRef
            .getDownloadURL()
            .then(
              function(url) {
                console.log(url);
                //Set DB record
                this.custom.logo = url;
              }.bind(vm)
            )
            .catch(function(error) {
              console.log("Error getting file:", error);
            });
        }
      );
    },
    customStylesBg(index) {
      var style = "";
      var custom = this.custom;
      if (index % 2 === 0) {
        //odd
        style = custom.obgcolor;
      } else {
        //even
        style = custom.ebgcolor;
      }
      return style;
    },

    customStylesFg(index) {
      var style = "";
      var custom = this.custom;
      if (index % 2 === 0) {
        //odd
        style = custom.otcolor;
      } else {
        //even
        style = custom.etcolor;
      }
      return style;
    },

    setColorCode(color_code) {
      this.color_code = color_code;
    },
    getBaseurl: function() {
      const base = window.location.host;
      this.base = base + "/polls/";
      //this.dropOptions.url = base;
    },

    todayStartDate: function() {
      this.range.start = moment().format("YYYY-MM-DD");
      var start = moment().format("HH");
      this.timeValueStart.HH = start;
      this.timeValueStart.mm = moment().format("mm");
      //END TIME

      var end = moment()
        .startOf("hour")
        .add(1, "hours")
        .format("HH");
      this.timeValueEnd.HH = end;
      this.timeValueEnd.mm = moment().format("mm");
    },

    editPoll: function() {
      this.pollKey = this.$route.params.pollId;
      const pollID = this.pollKey;

      if (pollID) {
        (this.options = [
          {
            title: "Edit questions and answer options",
            htmlContent: "q-a-form"
          },
          {
            title: "Customise your answer response",
            isActive: false,
            htmlContent: "custom-answer"
          },
          {
            title: "Edit Schedule poll - start and end dates and times",
            htmlContent: "time-date"
          },
          {
            title: "Edit poll customisations",
            htmlContent: "customise"
          }
        ]),
          (this.update_type = "Save Poll");
        this.title = "Edit your poll";

        var pollKey = this.$route.params.pollId;
        var firestore = firebase.firestore();
        var docRef = firestore.doc("polls/" + pollKey);

        docRef
          .get()
          .then(
            function(doc) {
              if (doc.exists) {
                var pollData = doc.data();
                this.question = pollData.question;
                this.author = pollData.author;

                this.answers = pollData.answers;
                this.answersCount = this.answers.length;

                // Date
                this.range.start = pollData.startDate;
                this.range.end = pollData.endDate;
                //Time
                var startTime = pollData.startTime;
                var startHour = startTime.split(":");
                this.timeValueStart.HH = startHour[0];
                this.timeValueStart.mm = startHour[1];

                var endTime = pollData.endTime;
                var endHour = endTime.split(":");
                this.timeValueEnd.HH = endHour[0];
                this.timeValueEnd.mm = endHour[1];

                //Custom message

                this.custom_answer = pollData.custom_answer;

                //Uid
                //this.userId = pollData.uid;

                if (pollData.custom) {
                  this.customProfiles = [];
                  this.custom = pollData.custom;
                  this.customProfiles = [pollData.custom];
                  this.selected_profile = pollData.custom.name;
                  this.getFBimage();
                }

                this.dateValidation();
                //console.log("Document data:", pollData);
              } else {
                // doc.data() will be undefined in this case
                console.log("No such document!");
              }
            }.bind(this)
          )
          .catch(function(error) {
            console.log("Error getting document:", error);
          });
      }
    },

    CreatePoll: function(e) {
      const uid = this.user.data.uid;
      const custom = this.custom;

      if (!this.question) {
        this.$modal.show("dialog", {
          title: "Whoops!",
          text: "You forgot to add an actual question.",
          buttons: [
            {
              title: "Okay",
              handler: () => {
                this.accr = 0;
                this.$modal.hide("dialog");
              }
            }
          ]
        });
        e.preventDefault();
        return;
      }

      if (this.isOverMonitorQuestion === true) {
        this.$modal.show("dialog", {
          title: "Whoops!",
          text: "Your question is a bit too long.",
          buttons: [
            {
              title: "Okay, ill sort it",
              handler: () => {
                this.accr = 0;
                this.$modal.hide("dialog");
              }
            }
          ]
        });
        e.preventDefault();
        return;
      }

      this.answers.forEach(answer => {
        if (answer.label == "") {
          this.$modal.show("dialog", {
            title: "Whoops!",
            text: "make sure all answers have content.",
            buttons: [
              {
                title: "Okay, let me sort that",
                handler: () => {
                  this.accr = 0;
                  this.$modal.hide("dialog");
                }
              }
            ]
          });
        }
      });

      if (!this.range.end) {
        this.$modal.show("dialog", {
          title: "Whoops!",
          text: "Don't forget an end date for your poll.",
          buttons: [
            {
              title: "Okay, let me sort that",
              handler: () => {
                this.accr = 1;
                this.$modal.hide("dialog");
              }
            }
          ]
        });
        e.preventDefault();
        return;
      }

      //Poll Type
      this.createArray.poll_type = "multiple";
      this.createArray.question = this.question;
      this.createArray.name = this.slug;
      //Answers Array
      this.createArray.answers = this.answers;
      //Date and Time
      this.createArray.startDate = this.range.start;
      this.createArray.endDate = this.range.end;
      this.createArray.startTime =
        this.timeValueStart.HH + ":" + this.timeValueStart.mm;
      this.createArray.endTime =
        this.timeValueEnd.HH + ":" + this.timeValueEnd.mm;
      // Set Defaults

      this.createArray.total = 0;
      this.createArray.views = 0;

      //Set User
      this.createArray.author = this.user.data.email;
      this.createArray.uid = this.user.data.uid;

      // Custom Style
      this.createArray.custom = this.custom;
      //Custom Answers
      this.createArray.custom_answer = this.custom_answer;

      var pollKey = this.pollKey;

      if (!pollKey) {
        var thePollKey = this.alphanumericUnique;
        //Save Poll Key
        this.pollKey = thePollKey;
      } else {
        var thePollKey = pollKey;
      }

      var firestore = firebase.firestore();
      var docRef = firestore.doc("polls/" + thePollKey);

      if (!pollKey) {
        // Loading
        this.$loading(true);

        docRef
          .set({
            //Poll Vars
            answers: this.createArray.answers,
            endDate: this.createArray.endDate,
            endTime: this.createArray.endTime,
            name: thePollKey,
            poll_type: this.createArray.poll_type,
            question: this.createArray.question,
            startDate: this.createArray.startDate,
            startTime: this.createArray.startTime,
            total: this.createArray.total,
            views: this.createArray.views,
            author: this.createArray.author,
            uid: this.createArray.uid,
            pollkey: thePollKey,
            custom: this.createArray.custom,
            custom_answer: this.createArray.custom_answer
          })
          .then(function() {
            console.log("Poll saved!");
            console.log(thePollKey);
            // Redirect When Finished

            window.location = "/share/" + thePollKey;
          })
          .catch(function(error) {
            console.log("got and error", error);
          });

        var docRefuser = firestore.doc("users/" + uid);
        //Update UserData
        docRefuser
          .update({
            profiles: custom
          })
          .then(function() {
            console.log("Profile saved!");
            // Redirect When Finished
          })
          .catch(function(error) {
            console.log("got and error", error);
          });

        e.preventDefault();
      } else {
        docRef
          .update({
            //Poll Vars
            answers: this.createArray.answers,
            endDate: this.createArray.endDate,
            endTime: this.createArray.endTime,
            poll_type: this.createArray.poll_type,
            question: this.createArray.question,
            startDate: this.createArray.startDate,
            startTime: this.createArray.startTime,
            custom: this.createArray.custom,
            custom_answer: this.createArray.custom_answer
          })
          .then(function() {
            console.log("Poll Updated!");
            console.log(thePollKey + "   " + uid);
            // Redirect When Finished

            var docRefuser = firestore.doc("users/" + uid);
            //Update UserData
            docRefuser
              .update({
                profiles: custom
              })
              .then(function() {
                console.log("Profile saved!");
                // Redirect When Finished
              })
              .catch(function(error) {
                console.log("got and error", error);
              });

            document.getElementById("publish").innerText = "Poll saved!";
            setTimeout(function() {
              document.getElementById("publish").innerText = "Edit poll";
            }, 3000);
          })
          .catch(function(error) {
            console.log("got and error", error);
          });

        e.preventDefault();
      }
    },

    isSelected: function(i) {
      return i === this.selected;
    },

    WindowWidth(e) {
      var windowWidth = window.innerWidth;
      if (windowWidth < 767) {
        this.gridType = "w-1/2";
      }
    },
    removeInput: function(index) {
      this.answers.splice(index, 1);
      this.answersCount = this.answers.length;
    },
    isOverQuestion: function() {
      return this.charactersRemainingQuestion < 0;
    },
    isOverAnswer: function() {
      return this.charactersRemainingAnswer < 0;
    }
  },
  computed: {
    alphanumericUnique() {
      return Math.random()
        .toString(36)
        .split("")
        .filter(function(value, index, self) {
          return self.indexOf(value) === index;
        })
        .join("")
        .substr(2, 8);
    },
    ...mapState({
      user: "user"
    }),
    OverlayHeight: function(i) {
      return this.previewheight / this.answersCount;
    },
    answersHeight() {
      if (this.answersCount > 2) {
        return this.OverlayHeight - 4;
      }
    },
    userEmail() {
      var email = this.user.data.email;
      //this.user = email;
      return email;
    },
    charactersRemainingQuestion: function() {
      if (this.maxCharacters - this.question.length < 0) {
        this.isOverMonitorQuestion = true;
      } else {
        this.isOverMonitorQuestion = false;
      }

      return this.maxCharacters - this.question.length;
    },
    charactersRemainingAnswer: function() {
      if (this.maxCharacters - this.custom_answer.length < 0) {
        this.isOverMonitorAnswer = true;
      } else {
        this.isOverMonitorAnswer = false;
      }

      return this.maxCharacters - this.custom_answer.length;
    },
    charactersOverQuestion: function() {
      return this.isOverQuestion()
        ? this.question.length - this.maxCharacters
        : 0;
    },
    charactersOverAnswer: function() {
      return this.isOverAnswer()
        ? this.custom_answer.length - this.maxCharacters
        : 0;
    }
  },
  mounted: function() {
    this.getBaseurl();
    this.todayStartDate();
    this.editPoll();
    this.loadUserProfile();
  }
};
</script>
